import React from 'react';
import '@ant-design/v5-patch-for-react-19' ; 

/* WithInfo Screen */
import WithInfoTop from './WithInfoTop';
import WithInfoLogin from '../../mobile/frame/WithInfoLogin';
import WithInfoContents from './WithInfoContents';
import WithInfoMsgModal from 'pages/components/WithInfoMsgModal';
import WithComPopup from 'pages/components/WithComPopup';
import { useAppSelector, useAppDispatch } from '../../../redux/hooks';
import { FrameAction } from '../../../redux/slice/frame/root_main_slice';
import { Layout, Modal, Spin } from 'antd';
import { useNavigate, useLocation, useNavigationType  } from "react-router";
import * as common from 'libs/common';


export let openPopup:any;
export let closeAllPopup:any;

const WithInfoMain: React.FC = () => {
    const [contentHeight, setContentHeight] = React.useState<number>(window.innerHeight);
    const [popupItems, setPopupItems] = React.useState([] as any);
    const activeKey       = useAppSelector((state) => state.Frame.activeKey);
    const lnbMenuItems    = useAppSelector((state) => state.Frame.lnbMenuItems);
    const allMenuItems    = useAppSelector((state) => state.Frame.allMenuItems);
    const msgItem         = useAppSelector((state) => state.Frame.msgItem);
    const showLoading     = useAppSelector((state) => state.Frame.showLoading);

    const defaultMenu = 'MCOM2021006';  // MCOM2021006
    const dispatch     = useAppDispatch();
    const navigate     = useNavigate();
    const location     = useLocation();
    const navigationType = useNavigationType();

    React.useEffect(() => {
        const loadStyles = async () => {
            await import('../../../mobile.css');
        };
      
        loadStyles();

        const updateHeight = () => {
            const headerHeight = 110;  // Header 높이
            setContentHeight(window.innerHeight - headerHeight);
        };
      
        window.addEventListener('resize', updateHeight);
        updateHeight();  // 초기 호출


        document.body.classList.add('fixed');  // 화면 스크롤 제거

        return () => {
            document.body.classList.remove('fixed');
            window.removeEventListener('resize', updateHeight);  // 클린업
        };
    }, []);

    React.useEffect(() => {
        if (activeKey) {
            if (navigationType !== 'POP') {
                navigate(`/${activeKey}`, { replace: false });
            } else {
                navigate(`/${activeKey}`, { replace: true });
            }
            
            if (lnbMenuItems) {
                const selectedMenu:any = allMenuItems.filter((item:any) => {
                    return item.key === activeKey;
                })[0];
                const selectedTopMenu:any = allMenuItems.filter((item:any) => {
                    return item.menuId === selectedMenu.upperMenuId;
                })[0];
        
                if (selectedTopMenu) {
                    dispatch(FrameAction.setCurrentTopMenuKey(selectedTopMenu.menuId));
                }

                if (selectedMenu) {
                    localStorage.setItem('scrnId', selectedMenu.pgmId);
                }
            }
        }
    }, [activeKey]);


    React.useEffect(() => {
        if (!jwtToken) {
            return;
        }
        let arrNav:any = [];
        if (location.pathname !== '/') {
            arrNav.push(location.pathname.substring(1));
            dispatch(FrameAction.setMdiItems(arrNav as []));
            dispatch(FrameAction.setActiveKey(location.pathname.substring(1)));

            if (!lnbMenuItems || lnbMenuItems.length < 1) {
                const currLnbMenuItem:any = allMenuItems.filter((lnb:any) =>{
                    return lnb.key === location.pathname.substring(1);
                })[0];
                const currTopMenuItem:any = allMenuItems.filter((item:any) => {
                    return item.menuId === currLnbMenuItem.upperMenuId;
                })[0];
                const currLnbMenuItems = allMenuItems.filter((lnb:any) =>{
                    return lnb.upperMenuId === currTopMenuItem.menuId
                });

                dispatch(FrameAction.setCurrentTopMenuKey(currTopMenuItem.menuId));
                dispatch(FrameAction.setLnbMenuItems(currLnbMenuItems as []));
                dispatch(FrameAction.setActiveKey(currLnbMenuItem.key));
            }
        } else {
            const currLnbMenuItems:any = allMenuItems.filter((lnb:any) =>{
                return lnb.upperMenuId === 'MCOM2021005' && lnb.key !== 'MCOM2021008';
            });
            
            dispatch(FrameAction.setCurrentTopMenuKey('MCOM2021005'));
            dispatch(FrameAction.setLnbMenuItems(currLnbMenuItems));
            dispatch(FrameAction.setActiveKey(defaultMenu));
            navigate('/' + defaultMenu, { replace: false });
        }
    }, [location]);

    const msgProps = React.useCallback(() => {
        return {...msgItem};
    }, [msgItem]);

    const jwtToken = useAppSelector((state) => state.Frame.jwtToken);

    openPopup = (params:any) => {
        const arr : any[] = [...popupItems];
        const exists : any[] = arr.filter((item:any) => {
            return params.popupId === item.popupId;
        });
        if (exists && exists.length > 0) {
            const msg = {
                title : '위드정보 확인',
                contents: '이미 열려있는 팝업 입니다.',
            };
            common.openInfo(msg);
        } else {
            arr.push(params);
            setPopupItems(arr);
        }

    }

    closeAllPopup = () => {
        setPopupItems([]);
    }

    const popupProps = React.useCallback((popupId:string) => {
        const popupProps = popupItems.filter((item:any) => {
            return item.popupId === popupId;
        })[0];

        const close = () => {
            let rtnArr;
            const tempArr = [...popupItems];
            const idx = tempArr.findIndex((item:any) => {
                return item.popupId === popupId;
            });
            const curr = tempArr.filter((item:any) => {
                return item.popupId === popupId;
            })[0];
            if(idx === 0){
                rtnArr = tempArr.slice(idx + 1, popupProps.length);
            }else{
                rtnArr = tempArr.slice(0, idx);
                rtnArr = rtnArr.concat(tempArr.slice(idx + 1, tempArr.length));
            }
            localStorage.setItem('scrnId', curr.openerId);

            setPopupItems(rtnArr);
        }

        const accept = (data:any) => {
            if (popupProps.accept && typeof popupProps.accept === 'function') {
                popupProps.accept(data);
                close();
            } else {
                close();
            }
        }
        const cancel = () => {
            if (popupProps.cancel && typeof popupProps.cancel === 'function') {
                popupProps.cancel();
                close();
            }
            close();
        }
        return {...popupProps, accept, cancel};
    }, [popupItems]);

    const contentStyle = {
        padding: 20,
        background: 'rgba(0, 0, 0, 0.05)',
        borderRadius: 4,
    };

    return (
        <Layout>
            {popupItems && popupItems.length > 0 ? 
                popupItems.map((item:any, idx:number) => {
                    const key = item.popupId;
                    return (
                        <WithComPopup key={key} {...popupProps(key)}/>
                        )})
                        : null
                    }
            <WithInfoMsgModal {...msgProps()}/>
            <Modal open={showLoading} footer={null} maskClosable={false} closable={false} style={{ display: "flex", justifyContent: "center", alignItems: "center", height : '80%' }} zIndex={9999}>
                <Spin size="small"><div style={contentStyle} /></Spin>
            </Modal> 
            {jwtToken ?
            <> 
                <div style={{ display: 'flex', flexDirection: 'column', height: '110px' }}>
                    <WithInfoTop/>
                </div>
                <div style={{ flex: '1 1 auto', height : contentHeight, overflowY: 'auto'}}>
                    <Layout className='main-layout-background'>
                        <WithInfoContents/>
                    </Layout>
                </div>
            </>
            :
            <WithInfoLogin/>}
        </Layout>
    );

}

export default WithInfoMain;